/**
 * The ONE rule for a record section over a React Query read (SA-464, the
 * SA-461 review's deferred minor): React Query keeps `data` when a refetch
 * fails, so a failed background refetch over a cached list must keep the
 * list and its last-good closed line, and the error line shows only when
 * there is nothing to show instead. "Nothing cached" is `data === undefined`
 * — an empty list and a `null` (a record with no process) are loaded values.
 */
export interface ReadState<T> { data: T | undefined; isError: boolean }

export function readUnavailable(q: ReadState<unknown>): boolean {
  return q.isError && q.data === undefined
}

/** The one word a section says when its read failed with nothing cached. It is a closed section's summary line, read
 * beside the section's title; a card's body says a whole sentence of its own (the Capacity card's is
 * `capacityText.UNAVAILABLE`), because there it stands alone. */
export const READ_UNAVAILABLE = 'unavailable'

export function readSummary<T>(q: ReadState<T>, words: (data: T | undefined) => string): string {
  return readUnavailable(q) ? READ_UNAVAILABLE : words(q.data)
}
